import { render, staticRenderFns } from "./userSidebar.vue?vue&type=template&id=4492d523&"
import script from "./userSidebar.vue?vue&type=script&lang=js&"
export * from "./userSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports